import { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";

const LangContext = createContext(null);

const DICT = {
  en: {
    hero_eyebrow: "India's first help network · free & paid",
    hero_title_1: "Rent a Mate,",
    hero_title_2: "by the minute or hour.",
    hero_sub: "A human-to-human help network — not a delivery, courier or maid app. Real, KYC-verified Mates, matched by service and location, with a HeylpMate check on both sides before we connect.",
    cta_book: "Book a Mate",
    cta_priority: "Priority ₹99/mo",
    cta_need_help: "I Need Help",
    cta_want_to_help: "I Want to Help",
    cta_earn: "Earn ₹25K+ /month",
    nav_services: "Services",
    nav_membership: "Priority ₹99",
    nav_about: "About",
    nav_become_mate: "Become a Mate",
    nav_earn: "Earn",
    footer_tag: "Real people. Real help.",
  },
  hi: {
    hero_eyebrow: "भारत का पहला मदद नेटवर्क · मुफ़्त और सशुल्क",
    hero_title_1: "एक Mate किराए पर लें,",
    hero_title_2: "मिनट या घंटे में।",
    hero_sub: "इंसान-से-इंसान मदद का नेटवर्क — कोई डिलीवरी या कूरियर ऐप नहीं। असली KYC-सत्यापित Mate, सेवा और स्थान के आधार पर मिलाए गए। जुड़ने से पहले HeylpMate दोनों तरफ बात करता है।",
    cta_book: "Mate बुक करें",
    cta_priority: "प्रायोरिटी ₹99/माह",
    cta_need_help: "मुझे मदद चाहिए",
    cta_want_to_help: "मैं मदद करना चाहता/चाहती हूँ",
    cta_earn: "₹25K+ /माह कमाएँ",
    nav_services: "सेवाएँ",
    nav_membership: "प्रायोरिटी ₹99",
    nav_about: "हमारे बारे में",
    nav_become_mate: "Mate बनें",
    nav_earn: "कमाएँ",
    footer_tag: "असली लोग। असली मदद।",
  },
  mr: {
    hero_eyebrow: "भारतातील पहिले मदत नेटवर्क · मोफत आणि सशुल्क",
    hero_title_1: "एक Mate भाड्याने घ्या,",
    hero_title_2: "मिनिटांत किंवा तासांत.",
    hero_sub: "माणसाकडून-माणसाकडे मदतीचे नेटवर्क — कोणतेही डिलिव्हरी किंवा कुरिअर अ‍ॅप नाही. खरे KYC-सत्यापित Mate, सेवा आणि ठिकाणानुसार जुळवलेले. जोडणीपूर्वी HeylpMate दोन्ही बाजूंशी बोलतो.",
    cta_book: "Mate बुक करा",
    cta_priority: "प्रायोरिटी ₹99/महिना",
    cta_need_help: "मला मदत हवी",
    cta_want_to_help: "मला मदत करायची आहे",
    cta_earn: "₹25K+ /महिना कमवा",
    nav_services: "सेवा",
    nav_membership: "प्रायोरिटी ₹99",
    nav_about: "आमच्याबद्दल",
    nav_become_mate: "Mate बना",
    nav_earn: "कमवा",
    footer_tag: "खरे लोक. खरी मदत.",
  },
};

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "hi", label: "हिन्दी", short: "हिं" },
  { code: "mr", label: "मराठी", short: "मरा" },
];

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("heylpmate_lang") || "en");

  const chooseLang = useCallback((code) => {
    setLang(code);
    localStorage.setItem("heylpmate_lang", code);
  }, []);

  const t = useCallback((key) => DICT[lang]?.[key] || DICT.en[key] || key, [lang]);

  const value = useMemo(() => ({ lang, chooseLang, t }), [lang, chooseLang, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
